<template>
  <div class="code-block">
    <h3 class="code-block__title">{{ $t('view.flow.block.code.title') }}</h3>
    <div class="code-block__code">
      <prism-editor
        @change="onInput"
        class="code-block__code-editor"
        v-model="val.code"
        line-numbers
        language="js"
      ></prism-editor>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  props: ['value', 'blockId'],
  data () {
    return {
      val: null
    }
  },
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    async beforeSave () {
      try {
        const signReq = await axios.post('/api/code/sign', {
          code: this.val.code,
        })
        this.val.sign = signReq.data.hash
      } catch (e) {
        this.notify('error', 'view.flow.error.codeSign')
        throw e
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.code-block {
  @include flowElementShadow();
  width: 70%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 12px 12px 12px;

  &__code {
    min-height: 100px;
  }

  &__code-editor {
    max-height: 50vh;
  }
}
</style>
